export type CreateDeploymentRequestDataKindNamesResponse = {
  warningMessage: string[] | null;
};
